// extracted by mini-css-extract-plugin
module.exports = {"label":"Textarea_label__atYuC","textarea":"Textarea_textarea__3jJdR","resizable":"Textarea_resizable__3kCQS"};